import React from 'react'

const Section = ({ section }) => {
  const { title, children } = section
  return (
    <div className='section'>
      <h6 className='sidebar-section-title'>{title}</h6>
      <div>
        {children.map(({ id, text, value }) => (
          <div className='label' key={id}>
            <span className='label-text'>{text}: </span>
            <span>{value}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Section
